const LOGIN_INSERT = "LOGIN_INSERT"; // 微信登录状态
const LOGIN_SIGNOUT = "LOGIN_SIGNOUT"; // 微信登录状态
export default {
  state: { status: false },
  mutations: {
    [LOGIN_INSERT](state, data) {
      state.status = data;
    },
    [LOGIN_SIGNOUT](state) {
      state.status = false;
    },
  },
  actions: {
    [LOGIN_INSERT]({ commit }, data) {
      commit(LOGIN_INSERT, data);
    },
    [LOGIN_SIGNOUT]({ commit }) {
      commit(LOGIN_SIGNOUT);
    },
  },
};
